import { type ContactData } from 'api/types/ContactData';
import { type RawContactData } from 'api/types/ContactData/RawContactData';

import { convertImgixUrl } from 'helpers/convertImgixUrl';

export const parseContactData = (data: RawContactData) => {
  const parsedData: ContactData = {
    address: data.address,
    archived: Boolean(data.archived),
    area: data.area,
    country: data.country,
    createdAt: new Date(data.created_at),
    emails: data.emails.map((email) => {
      return {
        contactUsId: email.contact_us_id,
        createdAt: new Date(email.created_at),
        email: email.email,
        id: email.id,
        updatedAt: new Date(email.updated_at),
      };
    }),
    id: data.id,
    image: convertImgixUrl(data.image),
    itemId: data.item_id,
    name: data.name,
    otherCopy: data.other_copy,
    phone: data.phone,
    position: data.position,
    title: data.title,
    updatedAt: new Date(data.updated_at),
    url: data.website,
  };

  Object.keys(parsedData).forEach((k) => {
    const key = k as keyof ContactData;

    if (parsedData[key] === '') {
      (parsedData[key] as string | null) = null;
    }
  });

  return parsedData;
};
